import React, { useState, useEffect } from 'react';
import './HeroSection.scss';

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.getElementById('hero-section');
      if (heroSection) {
        const rect = heroSection.getBoundingClientRect();
        const isInView = rect.top < window.innerHeight && rect.bottom > 0;
        setIsVisible(isInView);
      }
    };

    // Check on mount
    handleScroll();
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Count-up animation effect
  useEffect(() => {
    if (isVisible) {
      const animateCountUp = (element, target) => {
        let current = 0;
        const increment = target / 60; // 60fps animation
        const timer = setInterval(() => {
          current += increment;
          if (current >= target) {
            current = target;
            clearInterval(timer);
          }
          element.textContent = Math.floor(current) + (target === 320 ? ' GW+' : target === 60 ? '%' : '%');
        }, 16);
      };

      const statNumbers = document.querySelectorAll('.stat-number[data-count]');
      statNumbers.forEach((stat, index) => {
        setTimeout(() => {
          const target = parseInt(stat.getAttribute('data-count'));
          animateCountUp(stat, target);
        }, index * 200); // Stagger the animations
      });
    }
  }, [isVisible]);

  return (
    <section id="hero-section" className={`hero-section container ${isVisible ? 'animate' : ''}`}>
      <div className="hero-content">
        {/* Left Column - Orange Background */}
        <div className="hero-left">
          <div className="hero-text">
            <h1 className="hero-title">
              <span className="title-line-1">Empowering Africa's</span>
              <img src="/images/hero-section/Union.png" alt="Union" className="union-icon" />
              <span className="title-line-2">Future with Clean Energy</span>
            </h1>
            <p className="hero-description">
              Discover insights, trends, and breakthroughs shaping Africa's sustainable energy transition.
            </p>
            <button className="btn btn-white hero-cta">
              Learn More
            </button>
          </div>
        </div>


        {/* Center Arrow Icon */}
        {/* <div className="hero-center-arrow">
          <img src="/images/arrow-right.png" alt="Center Arrow" className="center-arrow-icon" />
        </div> */}

        {/* Right Column - Image Background with Statistics */}
        <div className="hero-right">
          <div className="hero-overlay">
            {/* Dismissible Banner */}
            <div className="hero-banner">
              <button className="banner-close">×</button>
              <p>Approximately 600 million Africans lack access to electricity, highlighting the urgent need for renewable energy solutions.</p>
            </div>
            
            <div className="hero-stats">
              <div className="stat-item stat-item-1">
                <div className="stat-number" data-count="320">0</div>
                <div className="stat-label">of untapped renewable energy potential.<img src="/images/hero-section/lightning.png" alt="Lightning" className="stat-icon" /></div>
              </div>
              <div className="stat-item stat-item-2">
                <div className="stat-number" data-count="60">0</div>
                <div className="stat-label">of the World's Best Solar Resources.<img src="/images/hero-section/sun.png" alt="Sun" className="stat-icon" /></div>
                <div className="stat-sublabel">Yet only 1% of global solar capacity installed is in Africa.</div>
              </div>
              <div className="stat-item stat-item-3 drop">
                <div className="stat-number" data-count="70">0</div>
                <div className="stat-label">Growth in Clean Energy Investment<img src="/images/hero-section/bulb.png" alt="Bulb" className="stat-icon" /></div>
                <div className="stat-sublabel">by 70% in the last 5 years.</div>
              </div>
            </div>
            
            {/* Bottom Navigation Button */}
            <div className="hero-bottom-nav">
              <button className="nav-button">
                <img src="/images/hero-section/arrow-right.png" alt="Arrow Right" className="nav-arrow" />
              </button>
            </div>
            
            {/* Bottom Description */}
            <div className="hero-bottom-description">
              <p>A digital platform tracking investments and impacts in energy access and clean energy across Africa.</p>
            </div>
          </div>
        </div>
        
        {/* Bottom Refresh Icon */}
        <div className="hero-bottom-refresh">
          <img src="/images/hero-section/refresh.svg" alt="Refresh" className="refresh-icon" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;